// eslint-disable-next-line func-names
document.addEventListener('DOMContentLoaded', function () {
  const videoWrappers = document.querySelectorAll('.video__wrapper');
  const players = new Map();

  function loadYouTubeAPI(callback) {
    if (window.YT) {
      callback();
      return;
    }
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
    window.onYouTubeIframeAPIReady = callback;
  }

  function extractVideoId(url) {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }

  function initializeYouTubePlayer(iframe) {
    const videoId = extractVideoId(iframe.src);

    // Create a new div to replace the iframe
    const playerDiv = document.createElement('div');
    playerDiv.id = `${iframe.id}-player`;
    iframe.parentNode.replaceChild(playerDiv, iframe);

    // eslint-disable-next-line no-new, no-undef
    new YT.Player(playerDiv.id, {
      height: '100%',
      width: '100%',
      videoId,
      playerVars: {
        autoplay: 0,
        controls: 1,
        rel: 0,
        enablejsapi: 1,
      },
      events: {
        onReady: (event) => {
          players.set(iframe.id, event.target);
          event.target.playVideo();
        },
      },
    });
  }
  // Function to play HTML5 video
  function playHTML5Video(video) {
    // Add controls attribute dynamically
    video.setAttribute('controls', 'controls');

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  // Play YouTube video using YouTube IFrame API
  function playYouTubeVideo(iframe) {
    if (!iframe.id) {
      iframe.id = `youtube-player-${Math.random()
        .toString(36)
        .substring(2, 9)}`;
    }

    if (!window.YT) {
      loadYouTubeAPI(() => initializeYouTubePlayer(iframe));
    } else {
      initializeYouTubePlayer(iframe);
    }
  }

  // Autoplay Vimeo video by modifying its URL
  function playVimeoVideo(iframe) {
    if (!iframe.src.includes('autoplay=1')) {
      iframe.src += `${iframe.src.includes('?') ? '&' : '?'}autoplay=1`;
    }
  }

  // Function to handle iframe videos (YouTube/Vimeo)
  function handleIframeVideo(iframe) {
    const { src } = iframe;
    if (src.includes('youtube.com')) {
      playYouTubeVideo(iframe);
    } else if (src.includes('vimeo.com')) {
      playVimeoVideo(iframe);
    }
  }

  // Ensure enablejsapi=1 is in YouTube iframe URLs
  document.querySelectorAll('iframe[src*="youtube.com"]').forEach((iframe) => {
    let { src } = iframe;
    if (!src.includes('enablejsapi=1')) {
      src += `${src.includes('?') ? '&' : '?'}enablejsapi=1`;
      iframe.src = src;
    }
  });

  videoWrappers.forEach((wrapper) => {
    const overlay = wrapper.querySelector('.video__overlay-wrapper');
    const videoElement = wrapper.querySelector('video, iframe');

    overlay.addEventListener('click', () => {
      // Hide the overlay
      overlay.classList.add('video__overlay-wrapper--hidden');

      // Determine if the video is HTML5, YouTube, or Vimeo
      if (videoElement.tagName.toLowerCase() === 'video') {
        playHTML5Video(videoElement);
      } else if (videoElement.tagName.toLowerCase() === 'iframe') {
        handleIframeVideo(videoElement);
      }
    });
  });
});
